module.exports = __webpack_public_path__ + "static/media/default-avatar.16ac13f8.jpg";